import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import ErrorPage from '../../errorPage/ErrorPage';
import NotFoundPage from 'errorPage/404';

class PublicRoute extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { component: Component, ...rest } = this.props;

    return [
      <Route
        {...rest}
        key='route'
        render={props => {
          if (!window.profile || (window.profile && window.profile.errorType === '404')) {
            return <NotFoundPage />;
          }

          if (window.profile && window.profile.clientStatusValue === 'Suspended') {
            props['errorType'] = 'suspended';
            return <ErrorPage {...props} {...rest} />;
          }

          if (window.profile && window.profile.errorType === 'general') {
            props['errorType'] = 'general';
            return <ErrorPage {...props} {...rest} />;
          }

          return <Component {...props} {...rest} />;
        }}
      />
    ];
  }
}

PublicRoute.propTypes = {
  location: PropTypes.any,
  component: PropTypes.any,
  authed: PropTypes.bool,
  external: PropTypes.bool
};

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/components/Router/PublicRoute.js